import { render } from "./DowngradeContract.vue?vue&type=template&id=e1a68a1e"
import script from "./DowngradeContract.vue?vue&type=script&lang=js"
export * from "./DowngradeContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__